import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { FC } from 'react'
import DesktopLogo from '../../assets/images/svg/logo-desktop.svg'
import MobileLogo from '../../assets/images/svg/logo-mobile.svg'
import useGame from '../../contexts/GameContext/useGame'
import usePageContext from '../../hooks/usePageContext'
import useWindowSize from '../../hooks/useWindowSize'
import { IS_IE11 } from '../../styles/device'
import theme from '../../styles/theme'
import ContextLink, { Links } from '../ContextLink'
import { IEWrapper, LogoContainer } from './Logo.styled'

interface LogoProps {
  animated?: boolean
  linkTo?: Links
  isNavOpen?: boolean
}

const Logo: FC<LogoProps> = ({
  animated = false,
  linkTo = null,
  isNavOpen,
}) => {
  const { width } = useWindowSize()
  const { headerBigLogoShown } = usePageContext()
  const { game } = useGame()
  const centered = !!headerBigLogoShown || false
  const { t } = useTranslation()

  const staticLogo =
    width >= 1024 || centered ? <DesktopLogo /> : <MobileLogo />
  const currentLogo = animated ? staticLogo : staticLogo

  return (
    <>
      <LogoContainer {...{ animated, centered }} data-testid='header-logo'>
        {animated && (width < 768 || IS_IE11) ? (
          <IEWrapper>
            <DesktopLogo className='animatedReplacement' />
          </IEWrapper>
        ) : (
          <>
            {linkTo ? (
              <ContextLink to={linkTo} aria-label={t('aria.label.logo') || ''}>
                {currentLogo}
                {game?.info.name && (
                  <h2
                    style={{
                      color: isNavOpen ? theme.colors.white : theme.colors.body,
                    }}
                  >
                    {game?.info.name}
                  </h2>
                )}
              </ContextLink>
            ) : (
              currentLogo
            )}
          </>
        )}
      </LogoContainer>
    </>
  )
}

export default Logo
